import {Selectors} from '../Settings';
import PartnersList from './PartnersList';

/**
 * PartnersLetters
 */
class PartnersLetters {
	constructor($partnersLetters) {
		this.$partnersLetters = $partnersLetters;
		this.$resetButton = this.$partnersLetters.find('.partners-letters-reset');

		this.bindHandlers();
	}

	bindHandlers() {
		let _self = this;

		this.$partnersLetters.find('ul li button').on('click', function() {
			_self.$resetButton.removeClass('act');
			_self.removeLettersActive($(this));
			_self.setLetterActive($(this));
			PartnersList.filterByLetter($(this).data('letter'));
		});

		this.$resetButton.on('click', function() {
			$(this).addClass('act');
			_self.removeLettersActive(null);
			PartnersList.removeFilter();
		});
	}

	setLetterActive($letter) {
		$letter.addClass('act');
	}

	removeLettersActive($clickedLetter) {
		this.$partnersLetters.find('ul li button').not($clickedLetter).removeClass('act');
	}
}

export default (new PartnersLetters($(Selectors.partnersLetters)));
